import React, { useEffect, useState } from "react";
import { useTranslation } from "@/langs/useTranslation";
import "../../css/storeManagement.scss";
import { Button, Form, Input, message, Select } from "antd";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import StoreEditBusinessHoursModal from "./StoreEditBusinessHoursModal";
import StoreSettingModal from "./StoreSettingModal";
import _ from "lodash";
import StoreApi from "@/apis/storeAPI";
import localforage from "localforage";
import PlatFormLoading from "@/components/loading";
import modalConfirm from "@/components/Modal/modalConfirm";
import { useGroupDeviceDispatch, useGroupDeviceState } from "./Provider";
import StoreAMapModal from "./StoreEditMapModal";
import StoreGoogleMapModal from "./StoreGoogleMapModal";

import HasPermission from "@/components/commons/HasPermission";
import { isCNDomain } from "@/helpers/utils";

const defaultBusinessHoursArr = [
  {
    value: 0,
    is24Hours: false, // 24小时营业
    isRest: false, // 休息
    timeList: []
  },
  {
    value: 1,
    is24Hours: false,
    isRest: false,
    timeList: []
  },
  {
    value: 2,
    is24Hours: false,
    isRest: false,
    timeList: []
  },
  {
    value: 3,
    is24Hours: false,
    isRest: false,
    timeList: []
  },
  {
    value: 4,
    is24Hours: false,
    isRest: false,
    timeList: []
  },
  {
    is24Hours: false,
    isRest: false,
    value: 5,
    timeList: []
  },
  {
    is24Hours: false,
    isRest: false,
    value: 6,
    timeList: []
  }
];

const StoreDetail = () => {
  const { t } = useTranslation();
  const storeStatusArr = [
    { name: t({ defaultMessage: "未开业" }), id: "0" },
    { name: t({ defaultMessage: "营业" }), id: "1" },
    { name: t({ defaultMessage: "停业" }), id: "2" },
    { name: t({ defaultMessage: "闭店" }), id: "3" }
  ];

  const WeekValueMap = [
    t({ defaultMessage: "星期日" }),
    t({ defaultMessage: "星期一" }),
    t({ defaultMessage: "星期二" }),
    t({ defaultMessage: "星期三" }),
    t({ defaultMessage: "星期四" }),
    t({ defaultMessage: "星期五" }),
    t({ defaultMessage: "星期六" })
  ];

  const { currentCompanyId, storeId, operateType } = useGroupDeviceState();

  const isCN = isCNDomain();

  const displayTime = item => {
    const timeList = item.timeList;
    if (item.is24Hours) return t({ defaultMessage: "24小时" });
    if (item.isRest) return t({ defaultMessage: "休息" });
    let strArr = [];
    _.map(timeList, item => {
      strArr.push(item.start + "~" + item.end);
    });
    return _.join(strArr, ",");
  };

  const { setShowDetail } = useGroupDeviceDispatch();
  const [state, setState] = useState({
    BusinessHoursArr: defaultBusinessHoursArr,
    showEditBusinessHoursDialog: false,
    selectWeekIndex: 0,
    CacheData: [],
    showStoreSettingModal: false,
    showStoreEditMapModal: false,
    addressArr: {
      store_address: "",
      lat: "",
      long: ""
    }
  });
  const [storeInfo, setStoreInfo] = useState({});
  const [storeDetailInfo, setStoreDetailInfo] = useState({});
  const [formDisabled, setFormDisabled] = useState(true);
  // 使用 formik 库 https://formik.bootcss.com/api/useFormik.html

  // const [formItem,setFormItem ] = useState(defaultFormValues)

  const [form] = Form.useForm();

  const resetState = () => {
    state.BusinessHoursArr = defaultBusinessHoursArr;
    state.showEditBusinessHoursDialog = false;
    state.selectWeekIndex = 0;
    state.CacheData = [];
    state.showStoreSettingModal = false;
    state.showStoreEditMapModal = false;
    state.addressArr = {
      store_address: "",
      lat: "",
      long: ""
    };
  };

  // 本组件相关方法
  const StoreDetailFunc = {
    // 取消
    handleCancel: () => {
      StoreDetailFunc.handleStartView();
      // setShowDetail(false)
    },
    getCompanyId: async () => {
      const user_company_id = await localforage.getItem("userCompanyID");
      return currentCompanyId ? currentCompanyId : user_company_id;
    },
    getDetail: async () => {
      resetState();
      const company_id = await StoreDetailFunc.getCompanyId();
      const res = await StoreApi.GetDetail({
        company_id: company_id,
        id: storeId
      });
      const groupInfo = res.group;
      const storeInfo = groupInfo.info;
      setStoreInfo(storeInfo);
      setStoreDetailInfo(groupInfo);
      let fieldValue = {
        name: groupInfo.name
      };
      if (storeInfo) {
        fieldValue = {
          name: groupInfo.name, // 门店名称
          store_name: storeInfo.store_name, // 门店简称
          store_code: storeInfo.store_code,
          status: String(storeInfo.status),
          contact: storeInfo.contact,
          contact_phone: storeInfo.contact_phone,
          contact_email: storeInfo.contact_email,
          charge: storeInfo.charge,
          charge_phone: storeInfo.charge_phone,
          charge_email: storeInfo.charge_email,
          store_address: storeInfo.store_address,
          location_address: storeInfo.location_address,
          lat: storeInfo.lat,
          long: storeInfo.lng,
          remark: storeInfo.remark
        };

        const HoursArr =
          storeInfo.business_hours && storeInfo.business_hours.length > 0
            ? storeInfo.business_hours
            : defaultBusinessHoursArr;
        HoursArr.sort((a, b) => {
          return a.value - b.value;
        });
        setState({
          ...state,
          BusinessHoursArr: HoursArr,
          addressArr: {
            store_address: storeInfo.store_address,
            lat: storeInfo.lat,
            long: storeInfo.lng
          }
        });
      }
      form.setFieldsValue(fieldValue);
    },

    handleSubmit: async values => {
      PlatFormLoading.show();
      const company_id = await StoreDetailFunc.getCompanyId();
      values.id = storeId;
      values.company_id = company_id;
      values.business_hours = state.BusinessHoursArr;
      values.store_address = state.addressArr.store_address;
      values.lat = state.addressArr.lat && state.addressArr.lat.toString();
      values.lng = state.addressArr.lat && state.addressArr.long.toString();
      const res = await StoreApi.StoreEdit(values).catch(error => {
        return false;
      });
      PlatFormLoading.hide();
      if (res && res.status === "success") {
        message.success(t({ defaultMessage: "保存成功" }));
        StoreDetailFunc.handleStartView();
        return;
      }
      message.error(t({ defaultMessage: "保存失败" }));
    },

    handleSubmitFailed: errorIfo => {
      console.log("----errorIfo---", errorIfo);
    },

    // 开启编辑
    handleStartEdit: () => {
      setShowDetail(true, storeId, "edit");
      setFormDisabled(false);
    },
    // 关闭编辑
    handleStartView: () => {
      setShowDetail(true, storeId, "show");
      setFormDisabled(true);
      // 刷新当前页面
      StoreDetailFunc.getDetail();
    },

    // 删除
    handleDel: async () => {
      const company_id = await StoreDetailFunc.getCompanyId();
      modalConfirm({
        title: t({ defaultMessage: "提示信息" }),
        content: t({ defaultMessage: "确定要删除吗？" }),
        onConfirm: async () => {
          StoreApi.Remove(storeId, company_id).then(res => {
            if (res.code === "400") {
              // if(res.message.errors)
              message.error(t({ defaultMessage: "删除失败" }));
              return;
            }
            message.success(t({ defaultMessage: "删除成功" }));
            setShowDetail(false);
          });
        }
      });
    }
  };

  // 编辑营业时间弹窗相关方法
  const EditBusinessHoursFunc = {
    // 编辑营业时间
    handleEditBusinessHours: (item, index) => {
      setState({
        ...state,
        showEditBusinessHoursDialog: true,
        selectWeekIndex: index,
        CacheData: _.cloneDeepWith(state.BusinessHoursArr, true)
      });
      setTimeout(() => {}, 0);
    },
    // 组件数据同步
    handleChangeCacheData(list) {
      setState({
        ...state,
        CacheData: list
      });
    },
    // 关闭
    handleEditBusinessHoursClose() {
      setState({
        ...state,
        showEditBusinessHoursDialog: false
      });
    },
    // 确认
    handleEditBusinessHoursConfirm(list) {
      setState({
        ...state,
        showEditBusinessHoursDialog: false,
        BusinessHoursArr: list
      });
    }
  };

  // 门店配置信息弹窗
  const StoreSettingFunc = {
    handleOpen: () => {
      setState({
        ...state,
        showStoreSettingModal: true
      });
    },
    handleClose: () => {
      setState({
        ...state,
        showStoreSettingModal: false
      });
    },
    handleConfirm: () => {
      setState({
        ...state,
        showStoreSettingModal: true
      });
    }
  };

  // 地图相关方法
  const EditMapFunc = {
    handleOpen: () => {
      setState({
        ...state,
        showStoreEditMapModal: true
      });
    },
    handleClose: () => {
      setState({
        ...state,
        showStoreEditMapModal: false
      });
    },
    handleConfirm: data => {
      setState({
        ...state,
        showStoreEditMapModal: false,
        addressArr: {
          store_address: data.store_address,
          lat: data.latitude,
          long: data.longitude
        }
      });
    }
  };

  useEffect(() => {
    // if(formItem.length<=0) {
    //   setFormItem(defaultFormValues)
    // }
    if (!storeId || storeId.length <= 0) {
      return;
    }
    setFormDisabled(operateType === "show");
    StoreDetailFunc.getDetail();
    getAllCountries();
    // SetSaleTimeArr(defaultSaleTimeArr)
  }, [storeId]);

  const MapModal = isCN ? StoreAMapModal : StoreGoogleMapModal;
  const [CountryName, SetCountryName] = useState("CN");
  const getAllCountries = async () => {
    const countries = await localforage.getItem("countries");
    const userDefaultCompanyCountryId = await localforage.getItem(
      "userDefaultCompanyCountryId"
    );
    // 获取当前用户默认公司所在的地区
    // console.log("-------countries-------",userDefaultCompanyCountryId,countries)
    countries.forEach(item => {
      if (item.id === userDefaultCompanyCountryId) {
        SetCountryName(item.name);
      }
    });
  };

  return (
    <div className={`store-detail-box`}>
      <div className={`title-box`}>
        <div className={`title-left`}>{t({ defaultMessage: "门店详情" })}</div>
        <div className={`title-right`}>
          <HasPermission permission="merchant_maintain_group">
            {operateType === "show" && (
              <Button
                variant="outlined"
                color="secondary"
                className={`btn del-btn`}
                onClick={() => {
                  StoreDetailFunc.handleDel();
                }}
              >
                {t({ defaultMessage: "删除" })}
              </Button>
            )}
          </HasPermission>
          <HasPermission permission="merchant_token">
            {operateType === "show" && (
              <Button
                variant="outlined"
                className={`btn store-setting-btn`}
                onClick={() => {
                  StoreSettingFunc.handleOpen();
                }}
              >
                {t({ defaultMessage: "门店配置信息" })}
              </Button>
            )}
          </HasPermission>

          <HasPermission permission="merchant_maintain_group">
            {operateType === "show" && (
              <Button
                variant="outlined"
                color="#00a6be"
                className={`btn edit-btn`}
                onClick={() => {
                  StoreDetailFunc.handleStartEdit();
                }}
              >
                {t({ defaultMessage: "编辑" })}
              </Button>
            )}
          </HasPermission>

          <HasPermission permission="merchant_maintain_group">
            {operateType !== "show" && (
              <Button
                variant="contained"
                color="#00a6be"
                className={`btn submit-btn`}
                onClick={() => {
                  form.submit();
                }}
              >
                {t({ defaultMessage: "确定" })}
              </Button>
            )}
          </HasPermission>

          {operateType !== "show" && (
            <Button
              variant="outlined"
              color="#00a6be"
              className={`btn cancle-btn`}
              onClick={() => StoreDetailFunc.handleCancel()}
            >
              {t({ defaultMessage: "取消" })}
            </Button>
          )}
        </div>
      </div>

      <div className={`form-box`}>
        <div className={`group-name`}>
          <div>{t({ defaultMessage: "基本信息" })}</div>
        </div>
        <Form
          name="basic"
          labelCol={{ span: 12 }}
          wrapperCol={{ span: 24 }}
          initialValues={{ remember: true }}
          autoComplete="off"
          labelAlign="left"
          layout="vertical"
          form={form}
          onFinish={StoreDetailFunc.handleSubmit}
          onFinishFailed={StoreDetailFunc.handleSubmitFailed}
          disabled={formDisabled}
        >
          <div className={`ant-form-item-box`}>
            <Form.Item
              label={t({ defaultMessage: "门店名称" })}
              name="name"
              rules={[
                {
                  required: true,
                  message: t({ defaultMessage: "门店名称不能为空!" })
                }
              ]}
            >
              <Input placeholder={t({ defaultMessage: "请填写名称" })} />
            </Form.Item>
            <Form.Item
              label={t({ defaultMessage: "门店简称" }) + ":"}
              name="store_name"
              rules={[{ max: 50 }]}
            >
              <Input placeholder={t({ defaultMessage: "请填写简称" })} />
            </Form.Item>
          </div>
          <div className={`ant-form-item-box`}>
            <Form.Item
              label={t({ defaultMessage: "门店编码" }) + ":"}
              name="store_code"
              rules={[{ max: 30 }]}
            >
              <Input placeholder={t({ defaultMessage: "请填写门店编码" })} />
            </Form.Item>
            <Form.Item
              label={t({ defaultMessage: "营业状态" }) + ":"}
              name="status"
              rules={[
                {
                  required: true,
                  message: t({ defaultMessage: "请选择营业状态!" })
                }
              ]}
            >
              <Select defaultValue={form.getFieldsValue("status")}>
                {storeStatusArr.map(item => {
                  return (
                    <Select.Option value={item.id} key={item.id}>
                      {item.name}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
          </div>

          <div className={`ant-form-item-box`}>
            <Form.Item
              label={t({ defaultMessage: "联系人" }) + ":"}
              name="contact"
              rules={[{ max: 30 }]}
            >
              <Input placeholder={t({ defaultMessage: "请填写" })} />
            </Form.Item>
            <Form.Item
              label={t({ defaultMessage: "联系人电话" }) + ":"}
              name="contact_phone"
            >
              <Input placeholder={t({ defaultMessage: "请填写" })} />
            </Form.Item>
          </div>

          <div className={`ant-form-item-box`}>
            <Form.Item
              label={t({ defaultMessage: "负责人" }) + ":"}
              name="charge"
              rules={[{ max: 30 }]}
            >
              <Input placeholder={t({ defaultMessage: "请填写" })} />
            </Form.Item>
            <Form.Item
              label={t({ defaultMessage: "负责人电话" }) + ":"}
              name="charge_phone"
            >
              <Input placeholder={t({ defaultMessage: "请填写" })} />
            </Form.Item>
          </div>

          <div className={`ant-form-item-box`}>
            <Form.Item
              label={t({ defaultMessage: "联系人邮箱" }) + ":"}
              name="contact_email"
              rules={[{ type: "email" }]}
            >
              <Input placeholder={t({ defaultMessage: "请填写" })} />
            </Form.Item>
            <Form.Item
              label={t({ defaultMessage: "负责人邮箱" }) + ":"}
              name="charge_email"
              rules={[{ type: "email" }]}
            >
              <Input placeholder={t({ defaultMessage: "请填写" })} />
            </Form.Item>
          </div>

          <div className={`ant-form-item-box-one address-form-item`}>
            <Form.Item
              label={t({ defaultMessage: "门店地址" }) + ":"}
              name="store_address"
            >
              {/*<Input placeholder="请填写"/>*/}
              <div
                className={`select-address`}
                style={{ pointerEvents: formDisabled ? "none" : "auto" }}
                onClick={() => {
                  EditMapFunc.handleOpen();
                }}
              >
                {state.addressArr.store_address &&
                state.addressArr.store_address.length > 0
                  ? state.addressArr.store_address
                  : t({ defaultMessage: "请选择门店地址" })}
              </div>
            </Form.Item>
          </div>
          <div className={`ant-form-item-box-one`}>
            <Form.Item label="" name="location_address">
              <Input placeholder={t({ defaultMessage: "请填写门店详情" })} />
            </Form.Item>
          </div>

          <div className={`ant-form-item-box-one`}>
            <Form.Item
              label={t({ defaultMessage: "备注" }) + ":"}
              name="remark"
              rules={[{ max: 500 }]}
            >
              <Input placeholder={t({ defaultMessage: "请填写" })} />
            </Form.Item>
          </div>
        </Form>

        <div className={`group-name`}>
          <div>{t({ defaultMessage: "营业时间" })}</div>
        </div>

        <div
          className={`sale-time-box`}
          style={{ pointerEvents: formDisabled ? "none" : "auto" }}
        >
          {state.BusinessHoursArr.map((item, index) => {
            return (
              <div className={`sale-time-box-item`} key={index}>
                <div className={`week-value`}>{WeekValueMap[item.value]}</div>
                <div className={`time-value`}>{displayTime(item)}</div>
                {operateType === "edit" && (
                  <div
                    className={`edit-icon`}
                    onClick={() => {
                      EditBusinessHoursFunc.handleEditBusinessHours(
                        item,
                        index
                      );
                    }}
                  >
                    <EditOutlinedIcon
                      fontSize="small"
                      style={{ color: "#00a6be" }}
                    ></EditOutlinedIcon>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
      {state.showEditBusinessHoursDialog ? (
        <StoreEditBusinessHoursModal
          list={state.CacheData}
          selectWeekIndex={state.selectWeekIndex}
          open={state.showEditBusinessHoursDialog}
          onClose={EditBusinessHoursFunc.handleEditBusinessHoursClose}
          onConfirm={EditBusinessHoursFunc.handleEditBusinessHoursConfirm}
        />
      ) : (
        ""
      )}

      <StoreSettingModal
        open={state.showStoreSettingModal}
        onClose={StoreSettingFunc.handleClose}
        rowData={storeDetailInfo}
        onConfirm={StoreSettingFunc.handleConfirm}
      />

      <MapModal
        key={state.showStoreEditMapModal ? "open" : "closed"} // 通过 key 强制重新渲染
        open={state.showStoreEditMapModal}
        onClose={EditMapFunc.handleClose}
        addressData={state.addressArr}
        CountryName={CountryName}
        onConfirm={EditMapFunc.handleConfirm}
      />
    </div>
  );
};

export default StoreDetail;
